import React from "react";
import { Col, Row } from "reactstrap";
import { Stack } from "react-bootstrap";

export const UserFormSkeleton = () => {
  return (
    <Row>
      {/* Arabic Name Field */}
      <Col md={4}>
        <Stack gap={1} className="mb-3">
          <div className="skeleton skeleton-form-label"></div>
          <div className="skeleton skeleton-form-input"></div>
        </Stack>
      </Col>

      {/* English Name Field */}
      <Col md={4}>
        <Stack gap={1} className="mb-3">
          <div className="skeleton skeleton-form-label"></div>
          <div className="skeleton skeleton-form-input"></div>
        </Stack>
      </Col>

      {/* National ID Field */}
      <Col md={4}>
        <Stack gap={1} className="mb-3">
          <div className="skeleton skeleton-form-label"></div>
          <div className="skeleton skeleton-form-input"></div>
        </Stack>
      </Col>

      {/* Nationality Field */}
      <Col md={4}>
        <Stack gap={1} className="mb-3">
          <div className="skeleton skeleton-form-label"></div>
          <div className="skeleton skeleton-form-select"></div>
        </Stack>
      </Col>

      {/* Gender Field */}
      <Col md={4}>
        <Stack gap={1} className="mb-3">
          <div className="skeleton skeleton-form-label"></div>
          <div className="skeleton skeleton-form-select"></div>
        </Stack>
      </Col>

      {/* Mobile Number Field */}
      <Col md={4}>
        <Stack gap={1} className="mb-3">
          <div className="skeleton skeleton-form-label"></div>
          <div className="d-flex align-items-center gap-2">
            <div className="skeleton skeleton-form-select-small"></div>
            <div className="skeleton skeleton-form-input flex-grow-1"></div>
          </div>
        </Stack>
      </Col>

      {/* Email Field */}
      <Col md={4}>
        <Stack gap={1} className="mb-3">
          <div className="skeleton skeleton-form-label"></div>
          <div className="skeleton skeleton-form-input"></div>
        </Stack>
      </Col>

      {/* Job Field */}
      <Col md={4}>
        <Stack gap={1} className="mb-3">
          <div className="skeleton skeleton-form-label"></div>
          <div className="skeleton skeleton-form-select"></div>
        </Stack>
      </Col>

      {/* Employer Field */}
      <Col md={4}>
        <Stack gap={1} className="mb-3">
          <div className="skeleton skeleton-form-label"></div>
          <div className="skeleton skeleton-form-select"></div>
        </Stack>
      </Col>

      {/* Sector Field */}
      <Col md={4}>
        <Stack gap={1} className="mb-3">
          <div className="skeleton skeleton-form-label"></div>
          <div className="skeleton skeleton-form-select"></div>
        </Stack>
      </Col>

      {/* Department Field */}
      <Col md={4}>
        <Stack gap={1} className="mb-3">
          <div className="skeleton skeleton-form-label"></div>
          <div className="skeleton skeleton-form-select"></div>
        </Stack>
      </Col>

      {/* Platform Permissions Section */}
      <Col md={12}>
        <Stack gap={1} className="mb-3">
          <div className="skeleton skeleton-form-section-title"></div>
          <div className="skeleton skeleton-form-permissions-area"></div>
        </Stack>
      </Col>

      {/* Groups Modal Section */}
      <Col md={4}>
        <Stack gap={1} className="mb-3">
          <div className="skeleton skeleton-form-label"></div>
          <div className="skeleton skeleton-form-button"></div>
        </Stack>
      </Col>
    </Row>
  );
};
